<template>
<PipelinePage :navNames="navNames"/>
</template>

<script>

import PipelinePage from '../Page.vue';

export default {
    components: {
        PipelinePage
    },

    data() {
        return {
            navNames: [
                'pipeline-advanced-field-mapper',
                'pipeline-advanced-file-type-normalizer',
                'pipeline-advanced-monitor'
                ]
        };
    }
}
</script>
